import { createWebHistory, createRouter } from "vue-router";

/* Main Views */
import Start from "@/views/main_views/Start.vue";
import About from "@/views/main_views/About.vue";
import Docs from "@/views/main_views/Docs.vue";
import Contact from "@/views/main_views/Contact.vue";
import MTB from "@/views/main_views/MTB.vue";
import API from "@/views/main_views/API.vue";

/* MTB-related Views */
import MTB_Preparation from "@/views/mtb_views/MTB_Preparation.vue";
import MTB_Slides from "@/views/mtb_views/MTB_Slides.vue";
import MTB_Config from "@/views/mtb_views/MTB_Config.vue";
import MTB_PatientList from "@/views/mtb_views/MTB_PatientList.vue";

/* Views about particular patients */
import Patient from "@/views/patient_views/Patient.vue";
import Patient_Activity from "@/views/patient_views/Patient_Activity.vue";
import Patient_PersonalData from "@/views/patient_views/Patient_PersonalData.vue";
import Patient_Variants from "@/views/patient_views/Patient_Variants.vue";
import Patient_Analysis from "@/views/patient_views/Patient_Analysis.vue";
import Patient_Recommendations from "@/views/patient_views/Patient_Recommendations.vue";
import Patient_VariantDetails from "@/views/patient_views/Patient_VariantDetails.vue"

/* Upload-related Views */
import Upload_Data from "@/views/upload_views/Upload_Data.vue";

/* Variant-related views */
import Variant_Details from "@/views/variant_views/Variant_Details.vue";
import Variant_SearchResults from "@/views/variant_views/Variant_SearchResults.vue";
import Variant_Pathogenicity from "@/views/variant_views/Variant_Pathogenicity";
import Variant_Protein from "@/views/variant_views/Variant_Protein.vue";
import Variant_Pathways from "@/views/variant_views/Variant_Pathways.vue";
import Variant_Treatments from "@/views/variant_views/Variant_Treatments.vue";
import Variant_NearbyTreatments from "@/views/variant_views/Variant_NearbyTreatments.vue";
import Variant_Transcripts from "@/views/variant_views/Variant_Transcripts.vue";
import Variant_Gene_Expression from "@/views/variant_views/Variant_GeneExpression.vue";
import Variant_VariantClassification from "@/views/variant_views/Variant_VariantClassification.vue";

/* InDel-related views */
import InDel_Details from "@/views/indel_views/InDel_Details.vue";
import InDel_Protein from "@/views/indel_views/InDel_Protein.vue";
import InDel_Treatments from "@/views/indel_views/InDel_Treatments.vue";

/* Gene-related Views */
import Gene_Details from "@/views/gene_views/Gene_Details.vue";
import Gene_Protein from "@/views/gene_views/Gene_Protein.vue";
import Gene_Treatments from "@/views/gene_views/Gene_Treatments.vue";
import Gene_Transcripts from "@/views/gene_views/Gene_Transcripts.vue";
import Gene_Gene_Expression from "@/views/gene_views/Gene_GeneExpression.vue";

/* Fusion-related Views */
import Fusion_Details from "@/views/fusion_views/Fusion_Details.vue"
import Fusion_Treatments from "@/views/fusion_views/Fusion_Treatments.vue"

/* Misc and test Views */
import Legal_Notice from "@/views/misc_views/Legal_Notice.vue";
import Layout_Test from "@/views/misc_views/Layout_Test.vue";
import Imprint from "@/views/misc_views/Imprint.vue";
import DataPrivacy from "@/views/misc_views/DataPrivacy.vue";
import Disclaimer from "@/views/misc_views/Disclaimer.vue";
import License from "@/views/misc_views/License.vue";

const routes = [
  {
    path: '',
    name: 'start',
    component: Start
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: { transition: 'slide-left' },
  },
  {
    path: '/docs',
    name: 'docs',
      component: () => import('../views/main_views/Docs.vue'),
      children: [
          {
            path: '/docs',
            name: "DocsWeb",
            component: () => import('../views/main_views/docs/OnkopusWebDoc.vue'),
          },
          {
            path: '/docs/python',
            name: "DocsPython",
            component: () => import('../views/main_views/docs/PythonPackageDoc.vue'),
          },
          {
            path: '/docs/knime',
            name: "DocsKNIME",
            component: () => import('../views/main_views/docs/KNIMEWorkflowsDoc.vue'),
          }
        ]
    },
  {
    path: '/contact',
    name: 'contact',
    component: Contact
  },
  {
    path: '/api',
    name: 'api',
    component: API
  },
  {
    path: '/test',
    name: 'Layout Test Area',
    component: Layout_Test
  },
  {
    path: "/upload",
    name: "UploadData",
    component: Upload_Data,
    props: true,
    children: [
      {
        path: '/upload/show-variant-interpretation-results/:id',
        name: "FileUploadResults",
        component: Variant_SearchResults
      },
      {
        path: '/upload/show-variant-interpretation-results-q',
        name: "SearchResults",
        component: Variant_SearchResults,
        meta: { transition: 'slide-left' },
      },
    ]
  },
  {
    path:"/show-variant-details-q/:id",
    name:"Variant Details",
    component: Variant_Details,
    props: true,
  },
  {
    path: '/show-gene-details/:id',
    name: "Gene Details",
    component: Gene_Details,
  },
  {
    path: '/show-gene-details/:id/protein',
    name: "Gene Protein",
    component: Gene_Protein,
  },
  {
    path: '/show-gene-details/:id/treatments',
    name: "Gene Treatments",
    component: Gene_Treatments,
  },
  {
    path:'/show-gene-details/:id/transcripts',
    name: "Gene Transcripts",
    component: Gene_Transcripts
  },
  {
    path:'/show-gene-details/:id/gene-expression',
    name: "Gene Expression",
    component: Gene_Gene_Expression
  },
  {
    path: '/show-indel-details/:id',
    name: "InDel Details",
    component: InDel_Details,
  },
  {
    path: '/show-indel-details/:id/protein',
    name: "InDel Protein",
    component: InDel_Protein,
  },
  {
    path: '/show-indel-details/:id/treatments',
    name: "InDel Treatments",
    component: InDel_Treatments,
  },
  {
    path: '/show-fusion-details/:id',
    name: "Fusion Details",
    component: Fusion_Details,
  },
  {
    path: '/show-fusion-details/:id/treatments',
    name: "Fusion Treatments",
    component: Fusion_Treatments,
  },
  {
        path:'/show-variant-details-q/:id/pathogenicity',
        name: "Variant Pathogenicity",
        component: Variant_Pathogenicity
  },
  {
        path:'/show-variant-details-q/:id/protein',
        name: "Variant Protein Interactions",
        component: Variant_Protein
  },
  {
        path:'/show-variant-details-q/:id/pathways',
        name: "Variant Pathways",
        component: Variant_Pathways
  },
  {
        path:'/show-variant-details-q/:id/treatments',
        name: "Variant Treatments",
        component: Variant_Treatments
  },
  {
        path:'/show-variant-details-q/:id/transcripts',
        name: "Variant Transcripts",
        component: Variant_Transcripts
  },
  {
        path:'/show-variant-details-q/:id/gene-expression',
        name: "Variant Gene expression",
        component: Variant_Gene_Expression
  },
  {
    path:'/show-variant-details-q/:id/variant-classification',
    name: "Variant Classification",
    component: Variant_VariantClassification
  },
  {
        path:'/show-variant-details-q/:id/nearby-treatments',
        name: "Variant Nearby Treatments",
        component: Variant_NearbyTreatments
  },
  {
    path:"/mtb",
    name:"Molecular Tumorboard",
    component: MTB,
    props: true,
    meta: {
        transition: 'slide-left'
    },
    children: [
        {
            path: '',
            redirect: '/mtb/get-ids',
            children: [
              {
                path:"/show-id/:id",
                name:"Patient",
                component: Patient,
                props: true,
                children: [
                  {
                    path: '',
                    redirect: to => { return { path: '/show-id-personal-data', query: { id: to.params.id } }},
                  },
                  {
                    path: "/show-id-activity",
                    name:"Patient Activity",
                    component: Patient_Activity,
                    props: true
                  },
                  {
                    path: "/show-id-personal-data",
                    name:"Patient Personal Data",
                    component: Patient_PersonalData,
                    props: true
                  },
                  {
                    path: "/show-id-variants",
                    name:"Patient Variants",
                    component: Patient_Variants,
                    props: true,
                  },
                  {
                    path: "/show-id-analysis",
                    name:"Patient Analysis",
                    component: Patient_Analysis,
                    props: true
                  },
                  {
                    path: "/show-id-recommendations",
                    name:"Patient Treatment Recommendations",
                    component: Patient_Recommendations,
                    props: true
                  },
                  {
                    path:"/show-variant-details/:id",
                    name:"Patient Variant Details",
                    component: Patient_VariantDetails,
                    props: true
                  },
                ]
              },
            ]
        },
        {
            path: '/mtb/get-ids',
            name: "MTB Patient List",
            component: MTB_PatientList
        },
        {
            path: "/mtb/mtb-preparation",
            name: "MTB Preparation",
            component: MTB_Preparation
        },
        {
            path: "/mtb/mtb-slides",
            name: "MTB Presentation",
            component: MTB_Slides,
        },
        {
          path: "/mtb/mtb-config",
          name: "MTB Configuration",
          component: MTB_Config,
        },
    ]
  },
  {
    path:"/legal-notice",
    name:"Legal Notice",
    component: Legal_Notice,
    props: true,
  },
  {
    path:"/imprint",
    name:"Imprint",
    component: Imprint,
    props: true,
  },
  {
    path:"/data-privacy",
    name:"Data Privacy",
    component: DataPrivacy,
    props: true,
  },
    {
    path:"/disclaimer",
    name:"Disclaimer",
    component: Disclaimer,
    props: true,
  },
    {
    path:"/license",
    name:"License",
    component: License,
    props: true,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  //mode: "hash",
  routes,
});

router.onError(error => {
    console.log("Routing error: ", error)
})

export default router;
